// src/pages/Checkout.tsx

import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import CheckoutComponent from "@/components/Checkout/Checkout";

const Checkout: React.FC = () => {
  const { t } = useTranslation("common");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("pages.checkout.title")}</title>
        <meta name="description" content={t("pages.checkout.description")} />
      </Helmet>

      <CheckoutComponent />
    </>
  );
};

export default Checkout;
